import { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import withStyles from 'beam/dist/styles'
import { CircularProgress } from 'beam/dist/Progress'
import Typography from 'beam/dist/Typography'
import { AutoSizer } from 'react-virtualized'
import AssociatedContactsGraph from './AssociatedContactsGraph'

const styles = theme => ({
  container: {
    width: '100%',
    height: '100%',
  },
  rootNoData: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    width: '100%',
    height: '100%',
  },
  listItem: {
    padding: theme.spacing(1),
    cursor: 'pointer',
  },
  title: {
    margin: theme.spacing(-1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
    backgroundColor: theme.palette.color.yellow[800],
  },
  bold: {
    fontWeight: 700,
  },
})
class AssociatedContacts extends Component {
  static propTypes = {
    contact: PropTypes.object,
    associatedContacts: PropTypes.array.isRequired,
    getAssociatedContacts: PropTypes.func.isRequired,
    onOpenContact: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    hasError: PropTypes.bool.isRequired,
    heightPerContact: PropTypes.number,
    t: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
  }

  static defaultProps = {
    contact: { id: null },
    heightPerContact: 24,
  }

  componentDidMount() {
    const { contact, getAssociatedContacts } = this.props

    getAssociatedContacts(contact)
  }

  hasAssociatedContacts() {
    const { contact, associatedContacts } = this.props

    if (associatedContacts.length === 0) {
      return false
    }

    return associatedContacts.length === 1 && associatedContacts[0].id === contact.id ? false : true
  }

  renderLoading() {
    const { classes } = this.props
    return (
      <div className={classes.rootNoData} data-testid="loading-container">
        <CircularProgress />
      </div>
    )
  }

  renderError() {
    const { classes, t } = this.props
    return (
      <div className={classes.rootNoData}>
        <Typography color="secondary" align="center">
          {t('error')}
        </Typography>
        <Typography color="secondary" align="center">
          {t('associatedContactsDataError')}
        </Typography>
      </div>
    )
  }

  renderData(heightStyle) {
    const { associatedContacts, contact, onOpenContact, heightPerContact } = this.props

    const autoSizerProps = heightStyle === 'auto' ? {} : { disableHeight: true }
    const heightDefault = heightStyle === 'auto' ? 0 : heightStyle

    return (
      <AutoSizer {...autoSizerProps}>
        {({ height = heightDefault, width }) => (
          <AssociatedContactsGraph
            associatedContacts={associatedContacts}
            selectedContactId={contact.id}
            openContact={onOpenContact}
            heightPerContact={heightPerContact}
            height={height}
            width={width}
          />
        )}
      </AutoSizer>
    )
  }

  render() {
    const { isLoading, hasError, associatedContacts, classes, t, heightPerContact } = this.props
    const heightStyle = associatedContacts.length ? associatedContacts.length * heightPerContact : 'auto'

    return !isLoading && !hasError && !this.hasAssociatedContacts() ? null : (
      <section>
        {!isLoading && !hasError ? (
          <Typography variant="body2" align="center" className={classes.title} classes={{ caption: classes.bold }}>
            {`(${associatedContacts.length}) ${t('associatedContacts')}`}
          </Typography>
        ) : null}
        <div style={{ height: heightStyle }}>
          {(isLoading && this.renderLoading()) ||
            (hasError && this.renderError()) ||
            (associatedContacts.length ? this.renderData(heightStyle) : null)}
        </div>
      </section>
    )
  }
}

export { AssociatedContacts as UnstyledAssociatedContacts }

export default withTranslation()(withStyles(styles)(AssociatedContacts))
